import { reactQueryGet } from "../helpers/backendRequestHelpers";
import { internalApi } from "../helpers/urlHelpers";

const fetch = () =>
  reactQueryGet(internalApi.communities.experimentationFlags.show());

export const experimentationFlagsApi = {
  fetch,
};
